import { Editor } from "@appquality/appquality-design-system";
import { useRef } from "react";
import { styled } from "styled-components";

const StyledEditor = styled(Editor)`
  border: 1px solid ${(props) => props.theme.colors.gray100};
`;

export const MarkdownEditor = ({
  onChange,
  initialValue,
  editable = true,
}: {
  onChange: (value: string) => void;
  initialValue: string;
  editable?: boolean;
}) => {
  const valueRef = useRef(initialValue);

  return (
    <StyledEditor
      editable={editable}
      onUpdate={({ editor }: { editor: any }) => {
        valueRef.current = editor.getMarkdown();
      }}
      onBlur={() => onChange(valueRef.current)}
      disableHeader
      disableSaveShortcut
      contentType="markdown"
      hasInlineMenu
    >
      {initialValue}
    </StyledEditor>
  );
};
